import {denormFn, normFn} from '../normalizerSupport';
import * as Types from './types';

export const normalize = normFn<Types.PanelSettingsObjSchema>(
  'panelSettings',
  whole => whole
);

export const denormalize = denormFn<Types.PanelSettingsObjSchema>(part => part);
